import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../AppModule/Context';
import {withExpertHomeContext} from '../../screens/ExpertHome/ExpertHomeContextProvider';

import MentorAiPillSelectorComponent from '../common/genericComponents/redesign/mentorAiPillSelectorComponent/mentorAiPillSelectorComponent';
import MentorPillComponent from '../common/genericComponents/redesign/mentorPillComponent/mentorPillComponent';
import MoveChatPopup from './moveChatPopup';
import ToolTipComponent from '../common/genericComponents/toolTipComponent';

import expertHomeService from '../../services/expertHomeService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './chatOwnershipComponent.css';

const CUSTOM_DD_ITEMS_IDS = {
  LINE_SEPARATOR: 'lineSeparator',
  TRANSITION_TO_PRIVATE_CHAT: 'transitionToPrivateChat',
  UNASSIGN_OWNERSHIP: 'unassignOwnership',
};

const CUSTOM_DD_ITEMS = {
  //will be passed to DropDownItem component
  [CUSTOM_DD_ITEMS_IDS.LINE_SEPARATOR]: {
    isLineSeparator: true,
  },
  [CUSTOM_DD_ITEMS_IDS.TRANSITION_TO_PRIVATE_CHAT]: {
    id: CUSTOM_DD_ITEMS_IDS.TRANSITION_TO_PRIVATE_CHAT,
    btnText: 'Transition to private chat',
  },
  [CUSTOM_DD_ITEMS_IDS.UNASSIGN_OWNERSHIP]: {
    id: CUSTOM_DD_ITEMS_IDS.UNASSIGN_OWNERSHIP,
    btnText: 'Un-assign ownership',
  },
};

const ChatOwnershipComponent = ({
  expertHomeContext = {},
  canChangeOwnership = false,
  isDisabled = false,
  isTeamChatRoom = false,
  showTransitionToMentorChatBtn = false,
  skipConfirmationPopUp = false,
  chatRoom = {},
  taskOwnerMentorId = null,
  roomOwnerObjectId = null,
  onMentorSelected = () => {}, // will call transitionTaskOwnership API
  onTransitionToMentorChat = () => {}, // will call transitionToMentorChat API
}) => {
  const context = useContext(AppContext);

  const [widgetDto, setWidgetDto] = useState(null);
  const [roomExtendedMentorDto, setRoomExtendedMentorDto] = useState(null);
  const [showMoveChatPopup, setShowMoveChatPopup] = useState(false);
  const [oneOnOneRoomMentorId, setOneOnOneRoomMentorId] = useState(null);
  const [customDdItems, setCustomDdItems] = useState([]);
  const [showToolTip, setShowToolTip] = useState(false);
  const [toolTipTxt, setToolTipTxt] = useState('');

  useEffect(() => {
    const widgetDtoExMentorDto =
      expertHomeService.getWidgetDtoExMentorDtoByTeamMentorIdOrMentorId(
        expertHomeContext.widgetDtos,
        roomOwnerObjectId,
      );
    const widgetDto = widgetDtoExMentorDto?.widgetDto;
    const extendedMentorDto = widgetDtoExMentorDto?.extendedMentorDto;
    setWidgetDto(widgetDto);
    setRoomExtendedMentorDto(extendedMentorDto);
  }, [roomOwnerObjectId]);

  useEffect(() => {
    let customDdItems = [];
    if (showTransitionToMentorChatBtn || taskOwnerMentorId) {
      customDdItems.push(CUSTOM_DD_ITEMS[CUSTOM_DD_ITEMS_IDS.LINE_SEPARATOR]);
    }
    if (showTransitionToMentorChatBtn) {
      customDdItems.push(
        CUSTOM_DD_ITEMS[CUSTOM_DD_ITEMS_IDS.TRANSITION_TO_PRIVATE_CHAT],
      );
    }
    if (taskOwnerMentorId) {
      customDdItems.push(
        CUSTOM_DD_ITEMS[CUSTOM_DD_ITEMS_IDS.UNASSIGN_OWNERSHIP],
      );
    }
    setCustomDdItems(customDdItems);
  }, [showTransitionToMentorChatBtn, taskOwnerMentorId]);

  useEffect(() => {
    if (widgetDto?.widgetAppCtrlDto && roomExtendedMentorDto?.mentorDto) {
      const toolTipTxt =
        roomExtendedMentorDto.mentorDto.mentorOwnerType ===
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.PERSONAL
          ? `One-on-one conversation \n Widget: ${widgetDto.widgetAppCtrlDto.name} \n Display name: ${roomExtendedMentorDto.mentorDto.displayName} \n Email: ${
              context.isAccountManager
                ? roomExtendedMentorDto.email
                : context.getCurrentUser().email
            }  \n Handle: ${roomExtendedMentorDto.mentorDto.profileName}`
          : `Shared team conversation \nDisplay name: ${roomExtendedMentorDto.mentorDto.displayName} \nWidget name: ${widgetDto.widgetAppCtrlDto.name.toUpperCase()}`;
      setToolTipTxt(toolTipTxt);
    }
  }, [
    widgetDto?.widgetAppCtrlDto?.name,
    roomExtendedMentorDto?.mentorDto?.displayName,
  ]);

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  const onDdOptionSelected = (ddOptionId) => {
    const isHalfPrivateMode =
      widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode ===
      VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE;
    if (ddOptionId === CUSTOM_DD_ITEMS_IDS.TRANSITION_TO_PRIVATE_CHAT) {
      setOneOnOneRoomMentorId(taskOwnerMentorId);
      setShowMoveChatPopup(true);
    } else if (taskOwnerMentorId !== ddOptionId) {
      if (
        !taskOwnerMentorId &&
        ddOptionId === VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI
      ) {
        // no need to call the api again as ooni is already assigned
        return;
      }
      const newTaskOwnerMentorId =
        ddOptionId === VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI ||
        ddOptionId === CUSTOM_DD_ITEMS_IDS.UNASSIGN_OWNERSHIP
          ? null
          : ddOptionId;
      if (isTeamChatRoom) {
        // team chat room
        if (isHalfPrivateMode && newTaskOwnerMentorId) {
          setShowMoveChatPopup(true);
          setOneOnOneRoomMentorId(ddOptionId);
        } else {
          if (skipConfirmationPopUp) {
            onMentorSelected(newTaskOwnerMentorId);
          } else {
            context.setNotificationPopUpData({
              notificationTxt:
                'Are you sure you would like to change the ownership of this chat?',
              notificationType:
                VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
              rejectBtnTxt: 'Yes, CHANGE',
              rejectBtnFunc: async () => {
                onMentorSelected(newTaskOwnerMentorId);
                context.closeNotificationPopUp();
              },
              closeBtnTxt: 'Close',
              closeBtnFunc: () => {
                context.closeNotificationPopUp();
              },
            });
            context.setShowNotificationPopUp(true);
          }
        }
      } else {
        // 1x1 chat room
        if (skipConfirmationPopUp) {
          onMentorSelected(newTaskOwnerMentorId);
        } else {
          context.setNotificationPopUpData({
            notificationTxt:
              'Are you sure you would like to change the ownership of this chat?',
            notificationType:
              VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
            rejectBtnTxt: 'Yes, CHANGE',
            rejectBtnFunc: async () => {
              onMentorSelected(newTaskOwnerMentorId);
              context.closeNotificationPopUp();
            },
            closeBtnTxt: 'Close',
            closeBtnFunc: () => {
              context.closeNotificationPopUp();
            },
          });
          context.setShowNotificationPopUp(true);
        }
      }
    }
  };

  const onTransition = (transitionChatRoomCloneRecipe) => {
    if (
      widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode ===
      VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE
    ) {
      // transitionTaskOwnership API
      onMentorSelected(oneOnOneRoomMentorId, transitionChatRoomCloneRecipe);
    } else {
      // transitionToMentorChat API
      onTransitionToMentorChat(
        oneOnOneRoomMentorId,
        transitionChatRoomCloneRecipe,
      );
    }
    closeMoveChatPopup();
  };

  const closeMoveChatPopup = () => {
    setOneOnOneRoomMentorId(null);
    setShowMoveChatPopup(false);
  };

  return (
    <div className="et-v2-chat-ownership-container">
      {showMoveChatPopup && (
        <MoveChatPopup
          isDisabled={isDisabled}
          chatRoom={chatRoom}
          formTitle={
            widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode ===
            VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE
              ? 'Assign to agent'
              : 'Move to one-on-one conversation'
          }
          onCancel={closeMoveChatPopup}
          onTransition={onTransition}
        />
      )}
      {widgetDto && (
        <>
          <div
            className="et-v2-coc-widget-owner-pill-component-wrap"
            onMouseEnter={handleToolTip}
            onMouseLeave={handleToolTip}>
            {/* <div className="et-v2-coc-widget-pill-component-wrap">
              <WidgetPillComponent
                isChatUI
                hideWidgetName
                widgetAppCtrlDto={widgetDto.widgetAppCtrlDto}
                hideToolTip
              />
            </div> */}
            {showToolTip && (
              <ToolTipComponent
                toolTipPosition={'right'}
                toolTipTxt={toolTipTxt}
              />
            )}
            <div className="et-v2-coc-owner-pill-wrap">
              <MentorPillComponent
                hideToolTip
                isChatUI
                isMentorSide
                extendedMentorDto={roomExtendedMentorDto}
                isSmallPill
              />
            </div>
          </div>
          <div className="et-v2-coc-mentor-pill-selector-wrap">
            <MentorAiPillSelectorComponent
              isDisabled={isDisabled || !canChangeOwnership}
              showAiBotInDD={expertHomeService.getIsOoniEnabledForMentor(
                widgetDto,
                roomExtendedMentorDto?.mentorDto?.mentorId,
              )}
              onlyVisibleMentorId={isTeamChatRoom ? null : roomOwnerObjectId}
              showAllMentorsOfWidget
              showMentorEmail={context.isAccountManager}
              roomExtendedMentorDto={roomExtendedMentorDto}
              selectorTitle={
                isTeamChatRoom &&
                widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode ===
                  VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE
                  ? 'Assign and route'
                  : 'Select owner'
              }
              customDdItems={customDdItems}
              selectedMentorId={taskOwnerMentorId}
              selectedWidgetId={widgetDto.widgetId}
              onMentorSelected={onDdOptionSelected}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default withExpertHomeContext(ChatOwnershipComponent);
